import React, { useEffect, useState } from "react";
import io from "socket.io-client";

const socket = io("https://fitness-junction-bots.onrender.com/");

const Chat = () => {
  const [chatMessage, setMessage] = useState("");

  const sendMessage = () => {
    if (chatMessage === "") return;
    let message = document.getElementById("send-message-input").value;
    let p = document.createElement("p");
    p.classList.add("my-message");
    p.innerText = message;
    document.getElementById("chat-body").append(p);
    document.getElementById("send-message-input").value = "";
    socket.emit("send-message", message);
  };
  const onPressEnter = (event) => {
    if (event.keyCode === 13) sendMessage();
  };
  useEffect(() => {
    socket.on("recieve-message", (message) => {
      let p = document.createElement("p");
      p.classList.add("other-message");
      p.innerText = message;
      document.getElementById("chat-body").append(p);
    });
  }, []);

  return (
    <div className="chat-container">
      <div className="chat-header text-center">
        <h4 className="fw-semibold">Community Chat</h4>
      </div>
      <div id="chat-body">
        <p className="other-message">Fitness Community</p>
      </div>

      <div className="chat-footer ">
        <input
          type="text"
          id="send-message-input"
          onKeyDown={onPressEnter}
          className="form-control"
          value={chatMessage}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Enter your message"
        />
        <button onClick={sendMessage} className="btn bot-btn mx-1">
          Send
        </button>
      </div>
    </div>
  );
};

export default Chat;
